import React from 'react'
import { Typography } from '@ann/web-components'
import { MyDriveContent, LoadingContainer, CircularProgress } from '../../pages/MyDrivePage/MyDrivePage.styled'
import SlideoutDriveCard from '../../../SlideoutDriveCard'
import SearchResults from '../SearchResults/SearchResults'

const DriveList = ({
    drives,
    onDriveClick,
    onDriveSelection,
    selectedDrives,
    isLoading,
    searchQuery
}) => {
    if (isLoading) {
        return (
            <LoadingContainer>
                <CircularProgress />
            </LoadingContainer>
        )
    }

    return (
        <>
            {searchQuery && (
                <SearchResults
                    searchQuery={searchQuery}
                    count={drives.length}
                    type="drive"
                />
            )}

            <MyDriveContent>
                {drives.map((vault) => (
                    <SlideoutDriveCard
                        key={vault.name}
                        title={vault.name}
                        description={vault.description}
                        ownerName={vault.createdBy}
                        lock={'89'}
                        version={'Version 1.3.2'}
                        documents={'10'}
                        checked={selectedDrives.includes(vault.vaultUuid)}
                        onChange={() => onDriveSelection(vault.vaultUuid)}
                        onDriveClick={() => onDriveClick(vault)}
                    />
                ))}
            </MyDriveContent>
        </>
    )
}

export default DriveList
